"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function rap(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M8.90214 4.85887V19.4674H6.29364V4.53262H8.90214V4.85887ZM10.7614 4.53262H12.2284C15.2614 4.53262 17.2834 6.45637 17.2834 9.19537C17.2834 11.4131 16.0759 13.1089 13.8911 13.6631L17.7064 19.4674H14.6411L9.42414 11.3801H11.9351C13.5979 11.3801 14.6411 10.6301 14.6411 9.16312C14.6411 7.69537 13.5986 6.94537 11.9351 6.94537H10.7936V4.53262H10.7614Z", fill: color }));
}
exports["default"] = rap;
//# sourceMappingURL=rap.js.map